export enum FindUpdateAction {
  DeactivateFind = 'DeactivateFind',
  DeleteFind = 'DeleteFind',
  KeepFindActive = 'KeepFindActive',
}

export enum FindUpdateDialogType {
  DeleteDialog = 'DeleteDialog',
  UpdateDialog = 'UpdateDialog',
}

export enum AssetViewType {
  RegularView = 'RegularView',
  TreeView = 'TreeView',
}
